import { useState, useEffect } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

let _cache = null;
let _promise = null;

/**
 * Shared hook to fetch canonical pricing data from the backend.
 * Caches the result so multiple components share a single fetch.
 * Returns { data, loading } where data matches GET /api/pricing/plans response.
 */
export function usePricing() {
  const [data, setData] = useState(_cache);
  const [loading, setLoading] = useState(!_cache);

  useEffect(() => {
    if (_cache) { setData(_cache); setLoading(false); return; }
    if (!_promise) {
      _promise = axios.get(`${API_URL}/api/pricing/plans`)
        .then(res => { _cache = res.data; return _cache; })
        .catch(() => null);
    }
    _promise.then(d => { setData(d); setLoading(false); });
  }, []);

  return {
    data,
    loading,
    startingPrice: data?.starting_price_label || '£29/month',
    trialDays: data?.trial?.days || 14,
    trialDescription: data?.trial?.description || '14-day free trial with full platform access. No credit card required.',
    currency: data?.currency_symbol || '£',
  };
}
